export const initialState = {
  menu: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
